<template>
  <div class="mb-widget" style="min-height:226px;"><!--the style is here so that it doesn't take effect until the app has loaded-->
    <div v-if="!isReady">
      <Spinner/>
    </div>
    <div v-if="isReady" style="position:relative;">
      <transition :name="transitionName">
        <router-view :key="$route.fullPath" :innerHTML="innerHTML" :styleId="styleId" :styleName="styleName" :sourceId="sourceId" :autoImport="autoImport"></router-view>
      </transition>
    </div>
  </div>
</template>

<script>
import inViewport from 'vue-in-viewport-mixin';
import Config from '@/config.js';
// import ImportApi from '@/services/importApi.js';

import Spinner from '@/components/Spinner';

export default {
  name: 'App',
  mixins: [ inViewport ],
  components: {
    Spinner
  },
  props: ['innerHTML', 'styleId', 'styleName', 'sourceId', 'autoImport'],
  data () {
    return {
      isReady: false,
      transitionName: 'fade-back',
      formattedReferenceTooltipTarget: null
    };
  },
  watch: {
    async 'inViewport.now' (isVisible) {
      if (isVisible) {
        await Config.loadServerSideConfig();
        this.isReady = true;
      }
    },
    '$route' (to, from) {
      const toDepth = to.path.split('/').length
      const fromDepth = from.path.split('/').length
      this.transitionName = toDepth === fromDepth ? 'no-transition' : toDepth < fromDepth ? 'fade-back' : 'fade-forward'
    }
  },
  mounted () {
    console.log(this.innerHTML);
  }
}
</script>

<style lang="scss">
  @import 'variables.scss';

.mb-widget { color:#2c3e50; font-family: 'Roboto', sans-serif; font-size:15px; line-height:1.5; margin:0 auto; max-width:620px; position:relative;
  a, article, body, code, dd, div, dl, dt, fieldset, footer, form, h1, h2, h3, h4, h5, h6, header, html, input[type=email], input[type=number], input[type=password], input[type=tel], input[type=text], input[type=url], legend, li, main, ol, p, pre, section, table, td, textarea, th, tr, ul { box-sizing: border-box; }
  ul { list-style-type: none; margin:0; padding:0; }
  button { background:none; border:none; color:inherit; cursor: pointer; font-family: 'Roboto', sans-serif; font-size:15px; outline:none;
    > span { align-items:center; display:flex; }
  }
  input, textarea { border:none; font-family: 'Roboto', sans-serif; font-size:15px; outline:none;
    &:focus { border-color:$secondary-color !important; }
  }
  a { color:inherit; text-decoration:none; }
  .btn { align-items:center; display:flex; padding:6px 12px;
    span > i:first-child { margin:0 6px 0 0; }
    &:hover { opacity:0.9; }
    &.btn-inline { display:inline-flex; margin-left:6px; margin-right:6px; }
    &[disabled] { filter:grayscale(100%); }
  }

  .btn-flat, .btn-outline, .btn-raised { border-radius:3px; font-weight:500; }
  .btn-outline { border:1px solid #b6c3d0; }
  .btn-raised { padding-top:7px; padding-bottom:7px; box-shadow:0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 1px 5px 0 rgba(0, 0, 0, 0.12); }

  .white { color:#ffffff; }
  .blue { color:$secondary-color; }
  .red { color:#f44336; }

  .bg-blue { background:$secondary-color; }
  .bg-orange { background: $primary-color; }

  .or-break { font-size:13px; margin: 10px 0; text-transform:uppercase; }
  .or-break:before, .or-break:after { background-color: rgba(0,0,0,0.1); content: ""; display: inline-block; height: 1px; position: relative; vertical-align: middle; width: 15%; }
  .or-break:before { right: 0.5em; margin-left: -50%; }
  .or-break:after { left: 0.5em; margin-right: -50%; }

  /* Transitions */
  .fade-enter-active, .fade-leave-active { transition: all .5s }
  .fade-enter, .fade-leave-to { opacity: 0 }

  .fade-forward-enter-active, .fade-forward-leave-active { transition: all .5s }
  .fade-forward-leave-active { left:0; position:absolute; right:0; top:0; }
  .fade-forward-enter, .fade-forward-leave-to { opacity: 0 }
  .fade-forward-enter { transform: translate3d(50px,0,0) }
  .fade-forward-leave-to { transform: translate3d(-50px,0,0) }

  .fade-back-enter-active, .fade-back-leave-active { transition: all .5s }
  .fade-back-leave-active { left:0; position:absolute; right:0; top:0; }
  .fade-back-enter, .fade-back-leave-to {  opacity: 0 }
  .fade-back-enter { transform: translate3d(-50px,0,0) }
  .fade-back-leave-to { transform: translate3d(50px,0,0) }
}
</style>



// WEBPACK FOOTER //
// src/App.vue